"use client"
import React from "react"
import Hero from "@/ui/screens/home/Hero"
import { Box } from "@mui/material"
import Grid from "@mui/material/Grid"
import CtaWrapper from "@/ui/screens/home/Cta"
import Cta2Wrapper from "@/ui/screens/home/Cta2"
import PricingWrapper from "@/ui/screens/home/Princing"
import ContactForm from "@/ui/screens/home/ContactForm"
import ValuesSection from "@/ui/screens/home/ValuesSection"
import FooterWrapper from "@/ui/layouts/FooterWrapper"
import PartnersCarousel from "@/ui/screens/home/PartnersCarousel"
import FaqList from "@/ui/screens/faq/FaqList"


export default function HomeWrapper() {
  const [isClient, setIsClient] = React.useState(false)

  React.useEffect(() => {
    setIsClient(true)
  }, [])

  return isClient && (
    <Box sx={{
      p: 2,
      flexGrow: 1,
      py: { xs: 3, md: 6 },
      pb: { xs: 3, md: 4 },
      color: "common.white"
    }}>
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        spacing={{ xs: 1, lg: 3 }}
      >
        <Grid size={{ xs: 12, sm: 12, md: 11, lg: 11, xl: 8 }}>
          <Hero />
          <PartnersCarousel />
          <ValuesSection />
          <CtaWrapper />
          <PricingWrapper />
          <Cta2Wrapper />
          <ContactForm />

          <Grid container justifyContent="center">
            <Grid size={{xs: 12, sm: 12, md: 10, lg: 9, xl: 9}}>
              <FaqList />
            </Grid>
          </Grid>

          <FooterWrapper />
        </Grid>
      </Grid>
    </Box>
  )
}
